import {ScrollTrigger} from "../LibrariesImport";

export default class BlockScrollingText1Image {
	static init() {
		this.blocks = document.querySelectorAll(".block-scrolling-text-1-image");

		this.blocks.forEach(block => {
			let texts = block.querySelectorAll(".scrolling-list-container .item");
			let images = block.querySelectorAll(".image-container img");

			texts.forEach((text, index) => {
				const image = block.querySelector(`[data-image-index="${text.dataset.itemIndex}"]`)
				ScrollTrigger.create({
					trigger: text,
					start: 'top 65%',
					end: 'bottom 65%',
					onEnter: () => {
						this.showImage(image, images);
					},
					onEnterBack: () => {
						this.showImage(image, images);
					}
				});
			});
		});
	}

	static showImage(image, images) {
		images.forEach(item => {
			item.classList.remove("active");
		});
		image.classList.add("active");
	}
}
